import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../services/api';
import Button from '../components/Button';
import Input from '../components/Input';
import { t } from '../i18n';
import './AuthPages.css';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [token, setToken] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await forgotPassword(email);
      setSuccess(true);
      // In development, we get the token back (remove in production)
      if (response.data.token) {
        setToken(response.data.token);
      }
    } catch (err: any) {
      setError(t('forgot.error.generic'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <img src="/logo.webp" alt="X-periences" className="auth-logo" />
          <h1 className="auth-title">{t('forgot.title')}</h1>
          <p className="auth-subtitle">{t('forgot.subtitle')}</p>
        </div>

        {!success ? (
          <form onSubmit={handleSubmit} className="auth-form">
            {error && <div className="auth-error">{error}</div>}
            
            <Input
              label={t('common.email')}
              type="email"
              placeholder={t('common.emailExample')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <Button type="submit" fullWidth loading={loading}>
              {t('forgot.submit')}
            </Button>
          </form>
        ) : (
          <div className="auth-form">
            <div className="form-success">
              {t('forgot.success')}
            </div>
            
            {token && (
              <div className="dev-info">
                <p style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
                  {t('forgot.devMode')}
                </p>
                <Link to={`/reset-password?token=${token}`}>
                  <Button variant="secondary" fullWidth>
                    {t('forgot.devGoReset')}
                  </Button>
                </Link>
              </div>
            )}
          </div>
        )}

        <div className="auth-footer">
          {t('forgot.remember')}{' '}
          <Link to="/login" className="auth-link">{t('common.signIn')}</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
